// extracted by mini-css-extract-plugin
export var benefitsContainer = "Index-module--benefitsContainer--o5SfC";
export var coloredBackground = "Index-module--colored-background--piGUy";
export var coursesContainer = "Index-module--courses-container--3vw82";